import { useTenant } from '../contexts/TenantContext';

export const AuthLayout = ({ children }) => {
    const { tenant, loading } = useTenant();

    if (loading) {
        return (
            <div className="min-h-screen flex items-center justify-center bg-slate-50">
                <div className="animate-pulse text-slate-400">Loading...</div>
            </div>
        );
    }

    return (
        <div className="auth-split-layout">
            {/* Left side - Branding */}
            <div 
                className="hidden lg:flex flex-col justify-between p-12"
                style={{ backgroundColor: tenant?.primary_color || '#0f172a' }}
            >
                <div>
                    {tenant?.logo ? (
                        <img src={tenant.logo} alt={tenant.name} className="h-10 object-contain" />
                    ) : (
                        <h1 className="text-2xl font-bold text-white">{tenant?.name || 'Referral Platform'}</h1>
                    )}
                </div>
                
                <div className="space-y-6">
                    <h2 className="text-4xl font-bold text-white leading-tight">
                        Empfehlen &<br />Prämien verdienen
                    </h2>
                    <p className="text-white/80 text-lg max-w-md">
                        Teilen Sie Ihr Netzwerk und verdienen Sie Punkte für jede erfolgreiche Empfehlung. Lösen Sie diese für attraktive Prämien ein.
                    </p>
                </div>
                
                <div className="text-white/60 text-sm">
                    Incentive-Plattform
                </div>
            </div>
            
            {/* Right side - Form */}
            <div className="flex items-center justify-center p-8 bg-slate-50">
                <div className="w-full max-w-md">
                    {/* Mobile logo */}
                    <div className="lg:hidden mb-8 text-center">
                        {tenant?.logo ? (
                            <img src={tenant.logo} alt={tenant.name} className="h-10 mx-auto object-contain" />
                        ) : (
                            <h1 
                                className="text-2xl font-bold"
                                style={{ color: tenant?.primary_color || '#0f172a' }}
                            >
                                {tenant?.name || 'Referral Platform'}
                            </h1>
                        )}
                    </div>
                    
                    {children}
                </div>
            </div>
        </div>
    );
};
